// extracted by mini-css-extract-plugin
export default {"container":"Hba-z","list":"Iba-z"};